import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { FiscalYearsPage } from '../../features/accounting/fiscal-years-page'

export const Route = createFileRoute('/_app/fiscal-years')({
  staticData: { crumb: 'fiscalYears' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'ledger.read'),
  component: FiscalYearsPage,
})
